import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Grid,
  TextField,
  Paper,
  IconButton,
  Card,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Colors from "../../utility/Colors";
import ConsentCollection from "../CreateABHA/ConsentCollection/ConsentCollection";
import AadharAuthentication from "../CreateABHA/AadharAuthentication/AadharAuthentication";
import CommunicationDetails from "../CreateABHA/CommunicationDetails/CommunicationDetails";
import AbhaAddressCreation from "../CreateABHA/AbhaAddressCreation/AbhaAddressCreation";
import { useDispatch, useSelector } from "react-redux";
import Methods from "../../utility/Methods";
import {
  aadharOtpThunk,
  createAbhaAddressThunk,
  enrollByAadharThunk,
  resendOtpAadharThunk,
} from "./reducer/abhaAadhar/thunk";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import ExistingAbhaProfile from "../CreateABHA/ExistingAbhaProfile/ExistingAbhaProfile.js";
import constants from "../../common/constants.js";
import { useNavigate } from "react-router-dom";
import BackdropComponent from "../../components/backdrop/index.tsx";
const steps = [
  "Consent Collection",
  "Aadhaar Authentication",
  // "Communication Details",
  "ABHA Address Creation",
];
export default function App() {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  // Aadhaar split fields state
  const [a1, setA1] = useState("");
  const [a2, setA2] = useState("");
  const [a3, setA3] = useState("");
  const [error, setError] = useState("");
  const [showAbhaSuccess, setShowAbhaSuccess] = useState({
    show: false,
    abhaId: "",
  });
  const consentRef = useRef(null);
  const aadharAuthRef = useRef(null);
  const communicationRef = useRef(null);
  const abhaRef = useRef(null);
  // Validate Aadhaar (12 digits total)
  const validateAadhaar = () => {
    const joined = "";
    if (!/^\d{12}$/.test(joined)) {
      setError("Please enter a valid 12-digit Aadhaar number.");
      return false;
    }
    setError("");
    return true;
  };
  const dispatch = useDispatch();
  const [txnId, setTxnId] = useState("");
  const [message, setMessage] = useState("");
  const [isNewFlag, setIsNewFlag] = useState(false);
  const [userMobile, setUserMobile] = useState("");

  const [abhaProfile, setAbhaProfile] = useState({
    status: false,
    data: {},
  });
  const aadhaarOtp = useSelector((state) => state.abhaAddress.aadhaarOtp);
  const {
    status: aadhaarOtpStatus,
    data: aadhaarOtpData,
    error: aadhaarOtpError,
  } = aadhaarOtp;

  const enrolByAadhar = useSelector((state) => state.abhaAddress.enrolByAadhar);
  const {
    status: enrolByAadharStatus,
    data: enrolByAadharData,
    error: enrolByAadharError,
  } = enrolByAadhar;

  const resendOtpAadhar = useSelector(
    (state) => state.abhaAddress.resendOtpAadhar
  );
  const {
    status: resendOtpAadharStatus,
    data: resendOtpAadharData,
    error: resendOtpAadharError,
  } = resendOtpAadhar;

  const createAbhaAddress = useSelector(
    (state) => state.abhaAddress.createAbhaAddress
  );
  const {
    status: createAbhaAddressStatus,
    data: createAbhaAddressData,
    error: createAbhaAddressError,
  } = createAbhaAddress;

  useEffect(() => {
    if (aadhaarOtpStatus === "succeeded") {
      console.log("enc res", aadhaarOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(aadhaarOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(aadhaarOtpData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      // handleShowSnackbar("success", "OTP sent successfully!");
      setActiveStep((s) => Math.min(s + 1, steps.length - 1));
    } else if (aadhaarOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(aadhaarOtpError?.data));
      handleShowSnackbar("error", decData?.error?.errorMessage);
    }
  }, [aadhaarOtpStatus]);

  useEffect(() => {
    if (resendOtpAadharStatus === "succeeded") {
      console.log("enc res", resendOtpAadharData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(resendOtpAadharData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(resendOtpAadharData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      // handleShowSnackbar("success", "OTP sent successfully!");
    } else if (resendOtpAadharStatus === "failed") {
      let decData =
        resendOtpAadharError?.data &&
        JSON.parse(Methods.decryptData(resendOtpAadharError?.data));
      console.log("error in resend OTP", decData);
      handleShowSnackbar("error", decData?.error?.errorMessage);
    }
  }, [resendOtpAadharStatus]);

  useEffect(() => {
    if (enrolByAadharStatus === "succeeded") {
      console.log("enc res", enrolByAadharData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(enrolByAadharData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(enrolByAadharData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setMessage(finalData?.message);
      console.log("finalData for isNew", finalData);
      // setActiveStep((s) => Math.min(s + 1, steps.length - 1));
      // setAbhaProfile({ status: true, data: finalData });
      if (finalData?.isNew) {
        setMessage(finalData?.message);
        setIsNewFlag(true);
        setAbhaProfile({ status: true, data: finalData });
        setActiveStep((s) => Math.min(s + 1, steps.length - 1));
      } else {
        setAbhaProfile({ status: true, data: finalData });
      }
    } else if (enrolByAadharStatus === "failed") {
      let decData =
        enrolByAadharError?.data &&
        JSON.parse(Methods.decryptData(enrolByAadharError?.data));
      handleShowSnackbar("error", decData?.error?.errorMessage);
    }
  }, [enrolByAadharStatus]);

  useEffect(() => {
    if (createAbhaAddressStatus === "succeeded") {
      console.log("enc res", createAbhaAddressData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(createAbhaAddressData?.data))
      );
      let decData = JSON.parse(
        Methods.decryptData(createAbhaAddressData?.data)
      );
      console.log("test ", decData.response);
      let finalData = decData.response;
      setShowAbhaSuccess({
        show: true,
        abhaId: finalData.preferredAbhaAddress,
      });
      // setTxnId(finalData?.txnId);
      // setMessage(finalData?.message);
      // handleShowSnackbar("success", "OTP sent successfully!");
    } else if (createAbhaAddressStatus === "failed") {
      let decData =
        createAbhaAddressError?.data &&
        JSON.parse(Methods.decryptData(createAbhaAddressError?.data));
      handleShowSnackbar("error", decData?.error?.errorMessage);
    }
  }, [createAbhaAddressStatus]);

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity,
      message,
    });
  };
  const [aadhaar, setAadhar] = useState("");
  const handleNext = () => {
    // if moving from Aadhaar step, validate
    // if (activeStep === 1) {
    //   if (!validateAadhaar()) return;
    // }
    console.log(activeStep, "activeStep");

    switch (activeStep) {
      case 0:
        let getAadhar = consentRef.current.getDetails();
        console.log(getAadhar, "getAadhar");
        if (getAadhar) {
          setAadhar(getAadhar);
          const reqObj = {
            loginId: getAadhar,
            loginHint: "aadhaar",
            scope: "aadhaar-verify",
            txnId: "",
          };
          let finalReqObj = Methods.encryptObject(reqObj);
          console.log("decrypted object", Methods.decryptObject(finalReqObj));

          dispatch(aadharOtpThunk(finalReqObj));
        } else {
          return;
        }
        break;
      case 1:
        let getOtp = aadharAuthRef.current.getDetails();
        if (getOtp) {
          setUserMobile(getOtp.mobileNumber); // Store user mobile
          let reqObj = {
            otp: getOtp.otp,
            txnId: txnId,
            mobile: getOtp.mobileNumber,
          };
          let finalReqObj = Methods.encryptObject(reqObj);
          console.log(
            "decrypted object verify otp",
            Methods.decryptObject(finalReqObj)
          );
          dispatch(enrollByAadharThunk(finalReqObj));
        } else return;
        break;
      // case 2:
      //   setActiveStep((s) => Math.min(s + 1, steps.length - 1));
      //   break;
      case 2:
        let getAbhaAddress = abhaRef.current.getDetails();
        if (getAbhaAddress) {
          let reqObj = {
            txnId: txnId,
            abhaAddress: getAbhaAddress,
            preferred: 1,
          };
          let finalReqObj = Methods.encryptObject(reqObj);
          console.log(
            "decrypted object abha address",
            Methods.decryptObject(finalReqObj)
          );
          dispatch(createAbhaAddressThunk(finalReqObj));
        } else return;
        break;
    }
  };
  const handleBack = () => setActiveStep((s) => Math.max(s - 1, 0));
  // click step like tabs
  const handleStepClick = (index) => setActiveStep(index);
  const handleSnackClose = () => {
    setSnackbarOpen({
      open: false,
      severity: "",
      message: "",
    });
  };
  const handleVerifyOtp = (otp, mobile) => {
    let reqObj = {
      otp: otp,
      txnId: txnId,
      mobile: mobile,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object verify otp",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(enrollByAadharThunk(finalReqObj));
  };

  const handleResendOtp = () => {
    const reqObj = {
      loginId: aadhaar,
      loginHint: "aadhaar",
      scope: "aadhaar-verify",
      txnId: "",
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    dispatch(resendOtpAadharThunk(finalReqObj));
  };

  return (
    <Card
      sx={{
        width: "100%",
        marginTop: "10px",
        // minHeight: "100vh",
        borderRadius: "10px",
        p: 2,
        boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
        "&:hover": {
          boxShadow: "#008080 0px 2px 5px",
        },
      }}
      className="abha_parent_box"
    >
      {abhaProfile.status === true && !isNewFlag ? (
        <ExistingAbhaProfile
          abhaProfile={abhaProfile.data}
          userMobile={userMobile}
          txnId={txnId}
        />
      ) : null}

      {(aadhaarOtpStatus === "pending" ||
        resendOtpAadharStatus === "pending" ||
        enrolByAadharStatus === "pending" ||
        createAbhaAddressStatus === "pending") && <BackdropComponent />}
      <SnackbarComponent
        message={snackbarOpen?.message}
        isOpen={snackbarOpen?.open}
        purpose={snackbarOpen?.severity}
        handleClick={handleSnackClose}
      />
      <Box>
        <Grid container>
          <Grid sm={12} xs={12}>
            <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
              Create ABHA Number Using Aadhaar
            </Typography>
          </Grid>
        </Grid>
        <Paper sx={{ p: 2, mb: 3 }}>
          <Stepper activeStep={activeStep} alternativeLabel fullWidth>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  // onClick={() => handleStepClick(index)}
                  sx={{ cursor: "pointer" }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>
        <Paper sx={{ p: 3 }}>
          {/* <Typography variant="h6" gutterBottom>
            {steps[activeStep]}
          </Typography> */}

          {/* Step contents */}
          {activeStep === 0 && (
            <Box>
              <ConsentCollection ref={consentRef} />
            </Box>
          )}

          {activeStep === 1 && (
            <AadharAuthentication
              ref={aadharAuthRef}
              onVerify={handleVerifyOtp}
              onResend={handleResendOtp}
              message={message}
            />
            // <Box component="form" sx={{ mt: 2 }}>
            //   <Typography variant="subtitle1" gutterBottom>
            //     Aadhaar number*
            //   </Typography>
            //   <Grid container spacing={2} alignItems="center">
            //     <Grid item xs={12} sm={4} md={2}>
            //       <TextField
            //         inputProps={{
            //           maxLength: 4,
            //           inputMode: "numeric",
            //           pattern: "[0-9]*",
            //         }}
            //         value={a1}
            //         onChange={(e) => setA1(e.target.value.replace(/\D/g, ""))}
            //         fullWidth
            //         placeholder="0000"
            //       />
            //     </Grid>
            //     <Grid item xs={12} sm={4} md={2}>
            //       <TextField
            //         inputProps={{
            //           maxLength: 4,
            //           inputMode: "numeric",
            //           pattern: "[0-9]*",
            //         }}
            //         value={a2}
            //         onChange={(e) => setA2(e.target.value.replace(/\D/g, ""))}
            //         fullWidth
            //         placeholder="0000"
            //       />
            //     </Grid>
            //     <Grid item xs={12} sm={4} md={2}>
            //       <TextField
            //         inputProps={{
            //           maxLength: 4,
            //           inputMode: "numeric",
            //           pattern: "[0-9]*",
            //         }}
            //         value={a3}
            //         onChange={(e) => setA3(e.target.value.replace(/\D/g, ""))}
            //         fullWidth
            //         placeholder="0000"
            //       />
            //     </Grid>

            //     <Grid item xs={12} md={6}>
            //       <Box display="flex" alignItems="center" gap={1}>
            //         <IconButton size="small" disabled>
            //           <VisibilityOffIcon />
            //         </IconButton>
            //         <Typography variant="body2" color="text.secondary">
            //           Please ensure that mobile number is linked with Aadhaar
            //           for OTP.
            //         </Typography>
            //       </Box>
            //     </Grid>
            //   </Grid>

            //   {error && (
            //     <Typography color="error" sx={{ mt: 1 }}>
            //       {error}
            //     </Typography>
            //   )}

            //   <Box sx={{ mt: 3 }}>
            //     <Button
            //       variant="contained"
            //       onClick={() => {
            //         if (validateAadhaar()) alert("OTP requested (mock)");
            //       }}
            //     >
            //       Request OTP
            //     </Button>
            //   </Box>
            // </Box>
          )}

          {/* {activeStep === 2 && <CommunicationDetails ref={communicationRef} />} */}

          {activeStep === 2 && <AbhaAddressCreation ref={abhaRef} />}
          {showAbhaSuccess.show && (
            <SuccessDialog
              open={true}
              abhaId={showAbhaSuccess.abhaId}
              onClose={() => {
                setShowAbhaSuccess({
                  show: false,
                  abhaId: "",
                });
                navigate(constants.PATH_ABHA_PROFILE, { replace: true });
              }}
            />
          )}
          {/* Navigation buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            {/* <Button disabled={activeStep === 0} onClick={handleBack}>
              Back
            </Button> */}

            <Box>
              <Button
                color="inherit"
                onClick={() => {
                  // if (activeStep > 0) setActiveStep((s) => 0);
                  // else
                  setTxnId("");
                  setMessage("");
                  setIsNewFlag(false);
                  consentRef.current = null;
                  aadharAuthRef.current = null;
                  communicationRef.current = null;
                  abhaRef.current = null;
                  navigate(constants.PATH_REGISTER);
                }}
                sx={{ mr: 1 }}
                className="abha_flow_cancel_btn"
              >
                {/* {activeStep > 0 ? "Reset" : "Cancel"} */}
                {"Cancel"}
              </Button>

              <Button
                variant="contained"
                onClick={handleNext}
                className="abha_flow_btn"
              >
                {activeStep === steps.length - 1 ? "Create ABHA" : "Next"}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Card>
  );
}

const SuccessDialog = ({ abhaId, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: "3rem", color: "green", mb: 1 }}
          />
          <Typography variant="h6" gutterBottom>
            Success
          </Typography>
          <Typography variant="body1">
            Your ABHA ID - <strong>{abhaId}</strong> has been created
            successfully.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          className="abha_flow_btn"
        >
          View Profile
        </Button>
      </DialogActions>
    </Dialog>
  );
};
